import React from "react";

const AudioIcon = (props: any) => {
  return (
    <svg width={70} height={71} fill="none" {...props}>
      <path
        fill="var(--color-stroke-active)"
        stroke="var(--color-stroke-active)"
        d="M23.246 66.353c-7.366 0-13.354-5.989-13.354-13.354 0-7.366 5.988-13.355 13.354-13.355C30.61 39.645 36.6 45.635 36.6 53S30.61 66.353 23.246 66.353Zm0-23.333c-5.497 0-9.98 4.482-9.98 9.979 0 5.497 4.483 9.979 9.98 9.979 5.497 0 9.979-4.482 9.979-9.98 0-5.495-4.452-9.978-9.98-9.978Z"
      />
      <path
        fill="var(--color-stroke-active)"
        stroke="var(--color-stroke-active)"
        d="M34.912 54.689c-.92 0-1.687-.768-1.687-1.688V12.168c0-.92.767-1.688 1.687-1.688s1.688.768 1.688 1.688v40.833c0 .924-.743 1.688-1.688 1.688Z"
      />
      <path
        fill="var(--color-stroke-active)"
        d="M55.796 30.338c-.963 0-1.984-.175-2.975-.496l-12.892-4.287c-4.025-1.342-7.175-5.717-7.175-9.946v-3.442c0-2.829 1.167-5.279 3.15-6.737 2.012-1.459 4.696-1.75 7.38-.875l12.89 4.287c4.026 1.342 7.176 5.717 7.176 9.946v3.413c0 2.829-1.167 5.279-3.15 6.737-1.254.963-2.8 1.4-4.404 1.4ZM40.308 8.434c-.7 0-1.342.175-1.837.554-.875.613-1.342 1.75-1.342 3.18v3.412c0 2.333 1.954 5.045 4.17 5.804l12.892 4.287c1.342.467 2.596.35 3.442-.262.875-.613 1.342-1.75 1.342-3.18v-3.412c0-2.333-1.954-5.046-4.171-5.804L41.912 8.726a4.68 4.68 0 0 0-1.604-.292Z"
      />
    </svg>
  );
};

export default AudioIcon;
